module.exports = ".color-component{\r\n    background-color:white!important;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/opc/opc-admin/color/color.component.css
// module id = ./src/opc/opc-admin/color/color.component.css
// module chunks = main